import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgLink = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M19.082 4.918a4.09 4.09 0 0 0-2.915-1.207 4.09 4.09 0 0 0-2.916 1.207l-2.709 2.71a4.076 4.076 0 0 0-1.06 1.855c-.677.176-1.31.53-1.855 1.06l-2.71 2.709a4.132 4.132 0 0 0 0 5.83 4.09 4.09 0 0 0 2.916 1.208 4.09 4.09 0 0 0 2.915-1.207l2.71-2.71c.53-.53.883-1.177 1.06-1.855a4.154 4.154 0 0 0 1.855-1.06l2.709-2.709c1.605-1.605 1.605-4.211 0-5.83Zm-7.053 9.497a2.283 2.283 0 0 1-.235.295l-2.71 2.709a1.772 1.772 0 0 1-1.251.515c-.457 0-.898-.176-1.252-.515a1.768 1.768 0 0 1 0-2.503l2.71-2.71a1.48 1.48 0 0 1 .294-.235c.206.545.515 1.046.957 1.487.442.442.942.751 1.487.957ZM12 12.001c-.014-.015 0 0 0 0-.014-.015 0 0 0 0 .015.014 0 0 0 0 .015.014 0 0 0 0Zm-.029-2.415c.074-.103.147-.206.236-.295l2.71-2.709a1.773 1.773 0 0 1 1.25-.515c.457 0 .899.176 1.252.515a1.768 1.768 0 0 1 0 2.503l-2.709 2.71a1.484 1.484 0 0 1-.294.235 4.155 4.155 0 0 0-.958-1.487 4.152 4.152 0 0 0-1.487-.957Zm1.075 6.375-2.709 2.71a3.557 3.557 0 0 1-5.006 0 3.52 3.52 0 0 1 0-4.992l2.709-2.71a3.35 3.35 0 0 1 1.31-.824 3.96 3.96 0 0 0 .074 1.252 2.347 2.347 0 0 0-.545.397l-2.709 2.71a2.364 2.364 0 0 0 0 3.327c.442.442 1.03.692 1.664.692.633 0 1.222-.25 1.664-.692l2.709-2.709a2.364 2.364 0 0 0 0-3.328h-.015a1.741 1.741 0 0 1-.456-1.649 3.54 3.54 0 0 1 1.295.825c1.385 1.37 1.385 3.607.015 4.991Zm5.625-5.624-2.71 2.709a3.348 3.348 0 0 1-1.31.824 3.96 3.96 0 0 0-.074-1.251c.192-.103.383-.236.545-.398l2.71-2.709a2.364 2.364 0 0 0 0-3.327 2.339 2.339 0 0 0-1.664-.692c-.634 0-1.223.25-1.664.692l-2.71 2.694a2.364 2.364 0 0 0 0 3.328h.015c.442.456.604 1.074.457 1.649a3.488 3.488 0 0 1-1.31-.81 3.52 3.52 0 0 1 0-4.992l2.709-2.709a3.557 3.557 0 0 1 5.006 0c1.369 1.37 1.369 3.608 0 4.992Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgLink;
